import { useState, useEffect } from 'react';

export default function useDeviceDetection() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleDeviceDetection = () => {
      const mobileCheck = window.matchMedia("(pointer: coarse) and (hover: none)").matches;
      setIsMobile(mobileCheck);
    };
    handleDeviceDetection();
    window.addEventListener('resize', handleDeviceDetection);
    return () => {
      window.removeEventListener('resize', handleDeviceDetection);
    };
  }, []);

  return isMobile;
};